import { __assign, __rest } from "tslib";
import { useState, useMemo, useCallback } from 'react';

var useMap = function useMap(initialMap) {
  if (initialMap === void 0) {
    initialMap = {};
  }

  var _a = useState(initialMap),
      map = _a[0],
      _set = _a[1];

  var stableActions = useMemo(function () {
    return {
      set: function set(key, entry) {
        _set(function (prevMap) {
          var _a;

          return __assign(__assign({}, prevMap), (_a = {}, _a[key] = entry, _a));
        });
      },
      setAll: function setAll(newMap) {
        _set(newMap);
      },
      remove: function remove(key) {
        _set(function (prevMap) {
          var _a = prevMap,
              _b = key,
              omit = _a[_b],
              rest = __rest(_a, [typeof _b === "symbol" ? _b : _b + ""]);

          return rest;
        });
      },
      reset: function reset() {
        return _set(initialMap);
      }
    };
  }, [_set]);

  var utils = __assign({
    get: useCallback(function (key) {
      return map[key];
    }, [map])
  }, stableActions);

  return [map, utils];
};

export default useMap;